import axios from 'axios';

/**
 * @author Michael Ballen <michael.ballen@gradiweb.com>
 * Get discounted price from API
 */
class CustomerDiscounts {

  /**
   * Assign customerdiscount component
   * @author Michael Ballen <michael.ballen@gradiweb.com>
   */
  constructor() {
    this.API_URL = "https://customer-groups-gr.herokuapp.com/discount";

    this.client = axios.create({
      baseURL: this.API_URL,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }

  /**
   * 
   * @param {Number} variantId 
   * @param {String} code 
   * @returns discounted price for selected variant
   */
  async getDiscountedPrice(variantId, code) {

    try {
      const response = await this.client.post(`${code}/product`, { variantId });
      return response.data.data.price;
    } catch (error) {
      console.error("Tried to apply discount code...")
    }
  }

  /**
   * 
   * @param {Number} * @param {Number} productId  
   * @param {Number} variantId 
   * @param {String} countryCode 
   * @param {String} code 
   * @returns discounted price for selected variant
   */
  async getDiscountedPriceByCurrency(productId , variantId, countryCode, code) {

    try {
      const response = await this.client.post(`${code}/productPrice`, { productId , variantId, countryCode });
      return response.data.data.price;
    } catch (error) {
      console.log("Tried to apply discount code...")
    }
  }

  /**
   * @param {String} code 
   * @returns get discounted percentage by code 
   */
  async getCustomerDiscountPercent(code) {
    try {
      const response = await this.client.post(`${code}`);
      return response.data;
    } catch (error) {
      console.log("Error GetCustomerDiscountPercent")
    }
  }
}

export { CustomerDiscounts };